var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20277 -1865)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20277 1865)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19644.271 -1452.484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-614.768,3345.438h-8.473a2.815,2.815,0,0,1-2.9-2.881q-.007-7.081,0-14.162a2.813,2.813,0,0,1,2.875-2.9c.981-.012,1.962,0,2.944,0q7.021,0,14.043,0a2.7,2.7,0,0,1,2.664,1.586,3.272,3.272,0,0,1,.288,1.342q.03,7,.01,14a2.869,2.869,0,0,1-3.017,3.022Zm-4.94-9.957c1.074,0,2.148-.009,3.221.006.293,0,.394-.078.391-.379-.014-1.206-.011-2.413,0-3.618,0-.268-.07-.374-.359-.373q-3.241.016-6.482,0c-.3,0-.429.078-.425.4.014,1.193.012,2.386,0,3.579,0,.292.1.392.394.389C-621.882,3335.473-620.8,3335.481-619.708,3335.481Zm.006,2.829c-1.074,0-2.148.01-3.221-.006-.32,0-.446.083-.442.422q.025,1.77,0,3.54c0,.321.118.414.417.413q3.241-.01,6.482,0c.267,0,.373-.078.369-.364-.014-1.206-.016-2.413,0-3.619,0-.334-.131-.4-.425-.392C-617.581,3338.318-618.642,3338.31-619.7,3338.31Zm6.406-7.168c-.013.133-.031.235-.031.337,0,1.206.01,2.412-.008,3.618,0,.33.118.392.417.39q3.2-.016,6.4,0c.359,0,.453-.123.448-.461-.016-1.139-.02-2.28,0-3.419.007-.386-.122-.5-.5-.493-2.107.016-4.214.008-6.321.009C-613.019,3331.124-613.148,3331.135-613.3,3331.142Zm3.516,11.534c1.06,0,2.12-.011,3.18.006.374.006.545-.08.534-.506-.029-1.139-.021-2.279,0-3.418.005-.347-.105-.457-.455-.455q-3.2.021-6.4,0c-.309,0-.416.081-.412.4.017,1.179.022,2.359,0,3.537-.007.367.125.444.457.439C-611.847,3342.665-610.813,3342.676-609.78,3342.676Z",
    transform: "translate(0 0)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon-card.25a62fdb.svg";
export { ForwardRef as ReactComponent };